import client from '../../base-api';

const serviceURL = '/analytics';

const analyticsBillingForecastService = {
    // BILLING FORECAST
    getBillingForecastPrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/billing-forecast/private-coaching`, {params: filterData});
    },
    getBillingForecastSocioTherapyCoachingList(filterData: any) {
        return client.get(`${serviceURL}/billing-forecast/socio-therapy-coaching`, {params: filterData});
    },
    getBillingForecastAssistedLivingCoachingList(filterData: any) {
        return client.get(`${serviceURL}/billing-forecast/assisted-living-coaching`, {params: filterData});
    },
    getTotalValues(filterData: any) {
        return client.get(`${serviceURL}/billing-forecast/total-values`, {params: filterData});
    },

    // COACH BILLING FORECAST
    getCoachBillingForecastPrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/coach-billing-forecast/private-coaching`, {params: filterData});
    },

}

export default analyticsBillingForecastService;